/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DocumentData } from '../../entities/v1/DocumentData'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1DocumentObjectStringSchema } from './documentObjectStringSchema'
import { z } from 'zod'

export const v1DocumentDataSchema = z.object({
  document_data_value: z.string().optional(),
  document_id: z.number().int().optional(),
  document_object_id: z.number().int().optional(),
  document_object_type: z.lazy(() => v1DocumentObjectStringSchema).optional(),
}) as unknown as ToZod<V1DocumentData>